import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Home, Compass } from "lucide-react";
import useSeo from "@/hooks/useSeo";

export default function NotFoundPage() {
  useSeo({
    title: "Page Not Found",
    description: "The page you're looking for doesn't exist. Return to ConnectHer's homepage.",
    path: "/404",
  });

  return (
    <section className="pt-20 md:pt-28 pb-24" data-testid="notfound-page">
      <div className="container-app max-w-3xl text-center">
        <div className="eyebrow flex items-center justify-center gap-2">
          <Compass className="w-3.5 h-3.5" /> Error 404
        </div>
        <h1 className="mt-4 text-6xl md:text-8xl leading-none font-serif">
          <span className="italic text-gold">Hmm.</span>{" "}
          Wrong turn.
        </h1>
        <p className="mt-6 text-lg text-navy/70 max-w-xl mx-auto leading-relaxed">
          The page you&apos;re looking for has moved, been renamed, or never existed.
          Let&apos;s get you back to something useful.
        </p>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link to="/" data-testid="notfound-home-cta" className="btn-primary">
            <Home className="w-4 h-4" /> Back to Home
          </Link>
          <Link
            to="/services"
            data-testid="notfound-services-cta"
            className="btn-secondary"
          >
            Browse Services <ArrowUpRight className="w-4 h-4" />
          </Link>
          <Link
            to="/contact"
            data-testid="notfound-contact-cta"
            className="btn-teal"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}
